import endpoints from '@/utils/constants';
import { apiHelper } from '@/utils/helpers';
const actions = {
    getJobList(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.jobs}`).then((res) => {
                if (res.status === 200) {
                    context.commit('setJobsList', res.data)
                }
            }).catch(err => {
                reject(err);
            })
        })
    },

    //save cost
    saveJob(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('post', `${endpoints.BASE_URL}${endpoints.API.jobs}`, context.state.job).then((res) => {
                if (res.status === 201) {
                    resolve(res);
                }
            }).catch(err => {
                reject(err);
            })
        })
    },

    //update cost
    updateJob(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('put', `${endpoints.BASE_URL}${endpoints.API.jobs}/${context.state.job.jobId}`, context.state.job).then((res) => {
                if (res.status === 200) {
                    context.commit('setJob', res.data);
                    resolve(res.data);
                }
            }).catch(err => {
                reject(err);
            })
        })
    },

    //edit labor cost
    fetchJob(context, jobId) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.jobs}/${jobId}`).then((res) => {
                if (res.status === 201) {
                    resolve(res.data);
                }
            }).catch(err => {
                reject(err);
            })
        })
    }
}

export default actions;